module.exports = __webpack_public_path__ + "img/no-photo.a1eb9c0f.svg";